import React from "react";
import StarIcon from "./StarIcon";
import PercentChange from "./PercentChange";
import { ExternalLink, LineChart } from "lucide-react";

const CoinCard = ({ coin, index, onOpenModal }) => {
  const priceFormatter = (num) => {
    if (num < 0.01) {
      return num.toFixed(6);
    } else if (num < 1) {
      return num.toFixed(4);
    } else {
      return new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        maximumFractionDigits: 2,
      }).format(num);
    }
  };

  const formatCompact = (num) => {
    if (!num) return "-";
    if (num >= 1e9) return (num / 1e9).toFixed(2) + " B$";
    if (num >= 1e6) return (num / 1e6).toFixed(2) + " M$";
    return num.toLocaleString() + " $";
  };

  return (
    <div className="coin-card" onClick={() => onOpenModal(coin)}>
      <div className="card-header">
        <div className="card-rank-info">
          <StarIcon coinId={coin.id} />
          <span className="rank-tag">#{index + 1}</span>
        </div>
        <button
          className="chart-trigger-btn"
          onClick={(e) => {
            e.stopPropagation();
            onOpenModal(coin);
          }}
          title="View detailed chart"
        >
          <LineChart size={16} />
        </button>
      </div>

      <div className="card-main">
        <img src={coin.image} alt={coin.name} className="coin-logo" />
        <div className="coin-names">
          <h3>{coin.name}</h3>
          <span className="coin-ticker">{coin.symbol.toUpperCase()}</span>
        </div>
      </div>

      <div className="card-price-section">
        <div className="price-display">{priceFormatter(coin.current_price)}</div>
        <PercentChange percent={coin.market_cap_change_percentage_24h} />
      </div>

      <div className="card-stats-grid">
        <div className="card-stat">
          <span className="stat-label">Market Cap</span>
          <span className="stat-val">{formatCompact(coin.market_cap)}</span>
        </div>
        <div className="card-stat">
          <span className="stat-label">24h Volume</span>
          <span className="stat-val">{formatCompact(coin.total_volume)}</span>
        </div>
        <div className="card-stat">
          <span className="stat-label">1 Hour</span>
          <PercentChange percent={coin.price_change_percentage_1h_in_currency} />
        </div>
        <div className="card-stat">
          <span className="stat-label">7 Days</span>
          <PercentChange percent={coin.price_change_percentage_7d_in_currency} />
        </div>
      </div>

      <div className="card-footer">
        <a
          href={`https://www.coingecko.com/en/coins/${coin.id.toLowerCase()}`}
          target="_blank"
          rel="noopener noreferrer"
          onClick={(e) => e.stopPropagation()}
          className="external-link"
        >
          <span>CoinGecko</span>
          <ExternalLink size={12} />
        </a>
      </div>
    </div>
  );
};

export default CoinCard;
